import { Controller } from "@hotwired/stimulus"

// Payment modal: split rows and only allow submit when the amounts equal the total.
export default class extends Controller {
  static targets = ["row", "amount", "remaining", "message", "submit", "addButton"]
  static values = { total: Number }

  connect() {
    this.recalc()
  }

  addRow(event) {
    event.preventDefault()
    const hidden = this.rowTargets.find((row) => row.classList.contains("d-none"))
    if (hidden) {
      hidden.classList.remove("d-none")
      const input = hidden.querySelector("input[type=number]")
      const remaining = this.totalValue - this.paid()
      if (remaining > 0) input.value = remaining.toFixed(2)
      this.recalc()
    }
    if (!this.rowTargets.some((row) => row.classList.contains("d-none"))) this.addButtonTarget.classList.add("d-none")
  }

  paid() {
    return this.amountTargets.reduce((sum, input) => {
      const visible = !input.closest("[data-order-payment-target='row']").classList.contains("d-none")
      return sum + (visible ? parseFloat(input.value) || 0 : 0)
    }, 0)
  }

  recalc() {
    const remaining = Math.round((this.totalValue - this.paid()) * 100) / 100
    this.remainingTarget.textContent = remaining.toFixed(2)
    const ok = remaining === 0
    this.submitTarget.disabled = !ok
    this.messageTarget.textContent = remaining > 0 ? "Payments don't cover the total yet." : (remaining < 0 ? "Payments exceed the total." : "")
  }
}
